import {
  Alert,
  BtnType,
  ButtonGf,
  ContenitoreBase,
  DettaglioItem,
  FormGf,
  Formatter,
  IcEmail,
  IcSelect,
  IcText,
  openLoading,
  setData,
  useApi
} from 'gf-ui'
import { useCallback, useEffect, useRef, useState } from 'react'
import { Col, Container, Row } from 'react-bootstrap'
import { useDispatch, useSelector } from 'react-redux'
import { Link, useNavigate } from 'react-router-dom'
import { TIPI_UTENTI_WEB } from '.'
import apiAutocompletes from '../api/apiAutocompletes'
import { apiConf } from '../api/apiConf'
import { FaPhone, FaTriangleExclamation } from 'react-icons/fa6'


const ProfiloUtente = () => {
  const user = useSelector(state => state.user)
  const pageData = useSelector(state => state.page.data)
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const _apiconf = useApi(apiConf)
  const _apiAutocompletes = useApi(apiAutocompletes)
  const shouldInit = useRef(true)
  const [initValues, setInitValues] = useState(null)
  const [tipiUtente, setTipiUtente] = useState([])
  const [idTipoUtenteWeb, setIdTipoUtenteWeb] = useState('')
  const [modificaAbilitata, setModificaAbilitata] = useState(false)

  const onSubmit = data => {    
    const datiUtente = {
      ...initValues,
      ...data,
      ID_UTENTE: pageData.DETTAGLIO_UTENTE.ID_UTENTE
    }

    _apiconf.fnSalvaDatiUtente(() => {
      openLoading(dispatch)
      let _pageData = {
        ...pageData,
        DETTAGLIO_UTENTE: {
          ...pageData.DETTAGLIO_UTENTE,
          ...datiUtente
        }
      }

      setData(dispatch, _pageData)

      setTimeout(() => {
        navigate('/')
      }, 500)
    }, datiUtente)
  }

  const getDatiUtente = useCallback(() => {
    setInitValues(null)

    _apiconf.fnDatiUtente(res => {
      let datiUtente = res.datiUtente

      const assegnate = datiUtente.UTENTI_WEB_TIPI.filter(u =>
        Formatter.getBoolean(u.FLG_ASSEGNATA)
      )

      datiUtente = {
        ...datiUtente,
        EMAIL: datiUtente.EMAIL,
        ID_UTENTI_WEB_TIPI: assegnate?.[0]?.KID?.toString?.() || ''
      }
      setModificaAbilitata(Formatter.getBoolean(res.flgModificaAbilitata))
      setInitValues(datiUtente)
      setIdTipoUtenteWeb(assegnate?.[0]?.KID)
    })
  }, [_apiconf])

  const onChange = data => {
    const _data = Formatter.getFormDataParams(data)

    if (
      _data &&
      _data.ID_UTENTI_WEB_TIPI &&
      _data.ID_UTENTI_WEB_TIPI.toString() !== idTipoUtenteWeb.toString()
    ) {
      setIdTipoUtenteWeb(_data.ID_UTENTI_WEB_TIPI)
      if (
        _data.ID_UTENTI_WEB_TIPI.toString() ===
        TIPI_UTENTI_WEB.MMG.toString() &&
        _data.SPECIALISTICA !== ''
      ) {
        setInitValues({
          ..._data,
          SPECIALISTICA: ''
        })
      }
    }
  }

  const getTipiUtenteWeb = useCallback(() => {
    _apiAutocompletes.fnTipiUtentiWeb(res => {
      setTipiUtente(res.data)
      getDatiUtente()
    })
  }, [_apiAutocompletes, getDatiUtente])

  useEffect(() => {
    if (shouldInit.current && pageData && _apiconf && _apiAutocompletes) {
      shouldInit.current = false
      getTipiUtenteWeb()
    }
  }, [getTipiUtenteWeb, pageData, _apiconf, _apiAutocompletes])

  return Formatter.getBoolean(pageData?.AUTORIZZATO) ? (
    <Container>
      <ContenitoreBase titolo='Utenza UNICA' className='bg-white pt-4 rounded'>
        <Row>
          <Col>
            <DettaglioItem label='Nominativo' value={user.nominativo} />
          </Col>
          <Col>
            <DettaglioItem label='Codice fiscale' value={user.codiceFiscale || initValues?.CODICE_FISCALE} />
          </Col>
          <Col>
            <DettaglioItem label='Email' value={initValues?.EMAIL} />
          </Col>
        </Row>
      </ContenitoreBase>
      <ContenitoreBase
        titolo='Profilo utente'
        className='bg-white pt-4 rounded'
      >
        {initValues && tipiUtente && (
          <>
            <FormGf
              id='frm-profilo-utente'
              gf_init={initValues}
              gf_submit={onSubmit}
              gf_onChange={onChange}
            >
              <Row>
                <Col xs={12} md={6} lg={4} xl={3}>
                  <IcText id='TELEFONO' label='Telefono' gf_icona={<FaPhone />} required />
                </Col>
                <Col xs={12} md={6} lg={4} xl={3}>
                  <IcEmail id='EMAIL' label='Email' required />
                </Col>
              </Row>

              {!modificaAbilitata && (
                <Alert variant="warning" className="mb-4 text-dark">
                  <div className='d-flex flex-row align-items-center justify-content-start'>
                    <FaTriangleExclamation color="var(--bs-danger)" style={{ minWidth: '16px', minHeight: '16px' }} /><strong className='mx-2'>Attenzione:</strong>La modifica dei dati professionali non è più possibile. Contattare l'assistenza per eventuali variazioni.
                  </div>
                </Alert>
              )}

              <Row>
                <Col xs={12} md={6} lg={4} xl={3}>
                  <IcText id='ASL' label='ASL' disabled={!modificaAbilitata} />
                </Col>
                <Col xs={12} md={6} lg={4} xl={3}>
                  <IcText id='DISTRETTO' label='Distretto' disabled={!modificaAbilitata} />
                </Col>
                <Col xs={12} md={6}>
                  <IcText id='STRUTTURA_SANITARIA' label='Struttura sanitaria' disabled={!modificaAbilitata} />
                </Col>
              </Row>

              <Row>
                <Col xs={12} md={6}>
                  {tipiUtente && (
                    <IcSelect
                      id='ID_UTENTI_WEB_TIPI'
                      label='Tipologia utente'
                      gf_options={tipiUtente}
                      required
                      disabled={!modificaAbilitata}
                    />
                  )}
                </Col>
                <Col xs={12} md={6}>
                  <IcText
                    id='SPECIALISTICA'
                    label='Disciplina'
                    disabled={idTipoUtenteWeb.toString() !== TIPI_UTENTI_WEB.SPECIALISTA.toString() || !modificaAbilitata}
                    required={idTipoUtenteWeb.toString() === TIPI_UTENTI_WEB.SPECIALISTA.toString()}
                  />
                </Col>
              </Row>
              <Row>
                <Col xs={12} md={6} lg={4} xl={3}>
                  <IcText id='NUM_ISCRIZIONE_ALBO' label="Num. d'iscrizione all'Albo" required disabled={!modificaAbilitata} />
                </Col>
              </Row>
              <Row>
                <Col className='d-flex flex-row align-items-center justify-conten-center'>
                  <ButtonGf
                    type='submit'
                    variant='primary'
                    gf_btn={BtnType.SAVE}
                    gf_label='Salva'
                  />
                </Col>
              </Row>
            </FormGf>
          </>
        )}
      </ContenitoreBase>
    </Container>
  )
    :
    <div className='w-100 h-100 d-flex flex-column align-items-center justify-content-center'>
      <h3 className='text-primary'>Utente non autorizzato</h3>
      <Link to="/" className='text-primary'>Torna alla home</Link>
    </div>
}

export default ProfiloUtente
